import * as React from "react";
import TextField from "@material-ui/core/TextField";
import {
    SimpleForm,
    Toolbar,
    SaveButton,
    DeleteButton,
} from "react-admin";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Checkbox,
    makeStyles,
    FormControlLabel,
    Typography,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Radio, TextField as RTextField, RadioGroup as RadioGroupMUI, Select, MenuItem, Button, DialogActions
} from "@material-ui/core";
import {useHistory, useLocation} from "react-router";
import {useEffect, useState} from "react";
import {getCreditsById} from "../../redux/credits/credits.actions";
import {useAppDispatch} from "../../redux/store";
import {getUser} from "../../redux/user/user.actions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import API from "../../helpers/apiHelpers";
import {useSnackbar} from "notistack";
import {RadioGroup} from "formik-material-ui";
import {Autocomplete} from "@material-ui/lab";
import {diets, dietTypes} from "../../Constants/diets";
import {insuranceList, insurances} from "../../Constants/insurance";
import {dogsAndCatsColors, generalColors} from "../../Constants/colors";
import {rhapsodyPetTypes} from "../../Constants/specialities";
import {ReactComponent as PetCatSVG} from "../../Images/petCat.svg";
import {ReactComponent as PetDogSVG} from "../../Images/petDogNew.svg";
import {ReactComponent as AddPetSVG} from "../../Images/addPetIcon.svg";
import {api_createAnimal, api_editAnimal} from "../../redux/pets/pets.api";
import moment from "moment";
import {colorInputBorder, colorInputBorderGrayish} from "../../Constants/theme";
import DateFnsUtils from "@date-io/date-fns";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {dogs} from "../../Constants/dogs";
import {cats} from "../../Constants/cats";
import {birds} from "../../Constants/birds";
import {amphibians} from "../../Constants/amphibians";
import {aquatic} from "../../Constants/aquatic";
import {mustelidae} from "../../Constants/mustelodae";
import {getAppointmentNotes} from "../../redux/appointment/appointment.actions";
import NotesListItem from "../ListItems/NotesListItem";
import {getAppointmentType} from "../../Constants/serviceType";

const useStyle = makeStyles((theme) => ({
    cancelBtn: {
        width: 180,
        marginLeft: 8,
        marginTop: 16,
    },
    dialog: {
        padding: "30px 0 30px 25px",
        width: "900px"
    },
    actions: {
        marginLeft: "auto",
        marginRight: "24px",
    },
    itemDivider: {
        borderBottom: `1px solid ${colorInputBorderGrayish}`
    },
    textPlain: {
        fontSize: 18,
        whiteSpace: "nowrap",
    },
    textSecondary: {
        fontSize: 18,
        marginBottom: 10,
    },
    formContainer: {
        border: "1px solid #DDDDDD",
        borderRadius: 5,
        padding: 17,
        marginTop: 22,
    },
    button: {
        justifyContent: "center",
    },
    listNotes: {
        maxHeight: 500,
        overflowY: "scroll",
        "&::-webkit-scrollbar": {
            width: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            background: colorInputBorder,
            borderRadius: "6px",
        },
    }
}));

const PetParentProfile = () => {
    const {state: {PetParentId, firstName, lastName, email, phone}} = useLocation<{ PetParentId: number, firstName: string, lastName: string, email: string, phone: string }>();
    const owner = useLocation();
    const [profileInfo, setProfileInfo] = useState(null);
    const [creditInfo, setCreditInfo] = useState({
        numberPurchasingAd: null,
        numberPurchasingRx: null,
        numberRemainingAd: null,
        numberRemainingRx: null,
        dateExAd: null,
        dateExRx: null,
    });
    const initialAnimal = {
        name: "",
        type: "",
        breed: "",
        dateOfBirth: null,
        weight: null,
        sex: "MALE",
        diet: [],
        neuteredSpayed: false,
        primaryColor: "",
        secondaryColor: "",
        insuranceProvider: "",
        otherInsuranceProvider: "",
        primaryVetName: "",
        primaryVetPhoneNumber: "",
        environment: "",
        numLitterBoxes: "",
        clinicEmail: "",
        pharmacyName: "",
        pharmacyPhone: "",
        medications: [],
    };
    const classes = useStyle();
    const {enqueueSnackbar} = useSnackbar();
    const history = useHistory();
    const [userInfo, setUserInfo] = useState(null);
    const [animals, setAnimals] = useState([]);
    const [selectedAnimal, setSelectedAnimal] = useState(null);
    const [linkToImage, setLinkToImage] = useState("");
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [primaryName, setPrimaryName] = useState("");
    const [primaryCare, setPrimaryCare] = useState(false);
    const [primaryPhone, setPrimaryPhone] = useState("");
    const [clinicEmail, setClinicEmail] = useState("");
    const dispatch = useAppDispatch();
    const [isView, setIsView] = useState(false);
    const [isNotesExpand, setNotesExpand] = useState(false);
    const [recordsList, setRecordsList] = useState(null);
    const [title, setTitle] = useState("");
    const [date, setDate] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const handleImageLoadError = () => {
        setLinkToImage("");
    };
    
    const handleNotes = async () => {
        try {
            const records = await dispatch(getAppointmentNotes(
                {animalId: selectedAnimal.id}
            ));
            setRecordsList(records);
            setNotesExpand(!isNotesExpand);
        } finally {
            setIsLoading(false);
        }
    };
    const handleNotesDetails = (id, selectedTitle, selectedDate) => {
        setSelectedRecord(recordsList.find(el=> el.id === id));
        setTitle(selectedTitle);
        setDate(selectedDate);
    };

    const handleSubmitPrimary = async () => {
        const {created, id,ownerId,imageUrl, ...animal} = selectedAnimal;
        const fieldToEdit = {
            ...animal,
            primaryVetName: primaryCare ? primaryName : "",
            primaryVetPhoneNumber: primaryCare ? primaryPhone : "",
            clinicEmail: primaryCare ? clinicEmail : "",
            diet: animal.diet?.map((currType) => dietTypes.find(({type}) => currType === type)?.value),
            primaryColor: animal.primaryColor.length ? animal.primaryColor.toUpperCase() : "",
            secondaryColor: animal.secondaryColor.length ? animal.secondaryColor.toUpperCase() : "",
            insuranceProvider: animal?.insuranceProvider?.length ? insurances.filter(item => item.label === animal.insuranceProvider)[0].value : null,
        };
        if (selectedAnimal.id) {
            api_editAnimal(selectedAnimal.id, {...fieldToEdit}).then(async (res) => {
                setSelectedAnimal(res);
                const pets = await API.getAnimalsByUserId(PetParentId);
                setAnimals(pets);
            });
        }
        else {
            api_createAnimal({...fieldToEdit, ownerId: PetParentId}).then(async (res) => {
                setSelectedAnimal(res);
                const pets = await API.getAnimalsByUserId(PetParentId);
                setAnimals(pets);
            })
        }
    };
    useEffect( () => {
        (async () => {
            try {
                dispatch(await getUser(PetParentId)).then(user => setUserInfo(user));
                const pets = await API.getAnimalsByUserId(PetParentId);
                setAnimals(pets);
                const creditsAdvice = await dispatch(await getCreditsById(PetParentId, "ADVICE"));
                const creditsRx = await dispatch(await getCreditsById(PetParentId, "DEFAULT"));
                const dateExAd = creditsAdvice[creditsAdvice.length - 1]?.expirationDate;
                const dateExRx = creditsRx[creditsRx.length - 1]?.expirationDate;
                const numberPurchasingAd = creditsAdvice.reduce((prev = 0, curr) => { return prev + curr?.creditRequestEntities?.length;}, 0);
                const numberPurchasingRx = creditsRx.reduce((prev = 0, curr) => { return prev + curr?.creditRequestEntities?.length;}, 0);
                const numberRemainingAd = creditsAdvice.reduce((prev = 0, curr) => {
                    return prev + curr?.creditRequestEntities?.filter(el => el.creditStatus === "CREATED").length;
                }, 0);
                const numberRemainingRx = creditsRx.reduce((prev = 0, curr) => {
                    return prev + curr?.creditRequestEntities?.filter(el => el.creditStatus === "CREATED").length;
                }, 0);
                setCreditInfo({
                    numberPurchasingAd: numberPurchasingAd,
                    numberPurchasingRx: numberPurchasingRx,
                    numberRemainingAd: numberRemainingAd,
                    numberRemainingRx: numberRemainingRx,
                    dateExAd: dateExAd,
                    dateExRx: dateExRx
                });
            }
            finally {
                setProfileInfo("");
            }
        })();
    },[]);
    const handleDelete = async () => {
        const resp = await API.deleteUser(PetParentId)
            .then((resp) => {
                enqueueSnackbar("Success!", {
                    variant: "success",
                    autoHideDuration: 2000
                });
                history.push("/searchPetParent");
            });
    };
    const CustomToolbar = props => (
        <Toolbar {...props}>
            <Button onClick={()=>setConfirmation(true)} style={{backgroundColor: "red", color: "white"}} variant="contained">Delete User</Button>
        </Toolbar>
    );
    const activeSub = userInfo?.ownerSubscriptionPlans?.find(el => el.ownerSubscriptionStatus === "CREATED");
    // @ts-ignore
    // @ts-ignore
    return (
        <SimpleForm toolbar={<CustomToolbar />}>
            {/* <TextInput disabled source="id" /> */}
            <Accordion
                style={{width: "100%", marginBottom: 10}}
                expanded={true}>
                <AccordionSummary
                    style={{fontWeight: 600}}
                    expandIcon={<ExpandMoreIcon/>}
                    id="general"
                >
                    General
                </AccordionSummary>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={firstName +  " " + lastName}
                        name={"name"}
                        label="Client Name"
                        fullWidth/>
                </AccordionDetails>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={phone}
                        name={"phone"}
                        label="Client Phone"
                        fullWidth/>
                </AccordionDetails>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={email}
                        name={"email"}
                        label="Client Email"
                        fullWidth/>
                </AccordionDetails>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={userInfo?.partnerEntity?.name ? userInfo?.partnerEntity?.name : "Hello Ralphie"}
                        name={"partner"}
                        label="White label partner"
                        fullWidth/>
                </AccordionDetails>
                {userInfo?.status === "DELETED" &&
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={"Deleted"}
                        name={"partner"}
                        label="Account Status"
                        fullWidth/>
                </AccordionDetails>
                }
                <AccordionSummary
                    style={{fontWeight: 600}}
                >
                    Advice credit info:
                </AccordionSummary>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={creditInfo.numberPurchasingAd || 0}
                        name={"adviceCredit"}
                        label="Number purchased:"
                        fullWidth/>
                </AccordionDetails>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={creditInfo.numberRemainingAd || 0}
                        name={"adviceRemaining"}
                        label="Number remaining & eligible to use:"
                        fullWidth/>
                </AccordionDetails>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={creditInfo?.dateExAd ? `${new Date(creditInfo?.dateExAd).getMonth()+1}/${new Date(creditInfo?.dateExAd).getDate()}/${new Date(creditInfo?.dateExAd).getFullYear()}` : "Not applicable"}
                        name={"adviceDate"}
                        label="Date when credits expire:"
                        fullWidth/>
                </AccordionDetails>
                <AccordionSummary
                    style={{fontWeight: 600}}
                >
                    RX credit info:
                </AccordionSummary>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={creditInfo.numberPurchasingRx || 0}
                        name={"RxCredit"}
                        label="Number purchased:"
                        fullWidth/>
                </AccordionDetails>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={creditInfo.numberRemainingRx || 0}
                        name={"RxRemaining"}
                        label="Number remaining & eligible to use:"
                        fullWidth/>
                </AccordionDetails>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={creditInfo?.dateExRx ? `${new Date(creditInfo?.dateExRx).getMonth()+1}/${new Date(creditInfo?.dateExRx).getDate()}/${new Date(creditInfo?.dateExRx).getFullYear()}` : "Not applicable"}
                        name={"RxDate"}
                        label="Date when credits expire:"
                        fullWidth/>
                </AccordionDetails>
                <AccordionSummary
                    style={{fontWeight: 600}}
                >
                    Subscription info:
                </AccordionSummary>
                <AccordionSummary>
                    Is this pet parent enrolled in the unlimited advice subscription plan?
                </AccordionSummary>
                <AccordionDetails>
                    <FormControlLabel
                        key={0}
                        control={
                            <Checkbox
                                key={0}
                                checked={activeSub?.created ? true : false}
                                name={"Yes"}
                                disabled
                            />
                        }
                        label={"Yes"}
                    />
                    <FormControlLabel
                        key={1}
                        control={
                            <Checkbox
                                key={1}
                                checked={activeSub?.created ? false : true}
                                name={"No"}
                                disabled
                            />
                        }
                        label={"No"}
                    />
                </AccordionDetails>
                <AccordionDetails>
                    <TextField
                        disabled
                        variant="filled"
                        value={activeSub?.created ? `${new Date(activeSub?.created).getMonth()+1}/${new Date(activeSub?.created).getDate()}/${new Date(activeSub?.created).getFullYear() + 1}` : "No subscription"}
                        name={"adviceDate"}
                        label="What date does the subscription plan expire?"
                        fullWidth/>
                </AccordionDetails>
                <AccordionSummary style={{fontWeight: 600}}>
                    Pets:
                </AccordionSummary>
                {animals.length ?
                    <Box padding="0px 18px" marginBottom="4px">
                        {animals.map(animal => <Typography onClick={()=> {
                            setOpenModal(true);
                            setSelectedAnimal({
                                ...animal,
                                diet: animal.diet && animal.diet.map((currValue) => dietTypes.find(({value}) => currValue === value)?.type),
                                primaryColor: animal.primaryColor ? animal["primaryColor"][0] + animal["primaryColor"].slice(1).toLowerCase() : "",
                                secondaryColor: animal.secondaryColor ? animal["secondaryColor"][0] + animal["secondaryColor"].slice(1).toLowerCase() : "",
                                insuranceProvider: animal.insuranceProvider ? insurances.filter(item => item.value === animal["insuranceProvider"])[0].label : "",
                            });
                            setLinkToImage(animal.imageUrl);
                            setPrimaryName(animal.primaryVetName);
                            setPrimaryCare(!!animal.primaryVetName?.length);
                            setPrimaryPhone(animal.primaryVetPhoneNumber);
                            setClinicEmail(animal?.clinicEmail ? animal?.clinicEmail : "");
                        }
                        } style={{fontSize: "14px", marginBottom: "4px", cursor: "pointer"}} key={animal.id}>
                            {animal.name}
                        </Typography>)}
                        <Button style={{marginBottom: "15px", marginTop: "10px"}} variant="contained" onClick={() => {
                            setOpenModal(true);
                            setSelectedAnimal(initialAnimal);
                        }}>Add New Pet</Button>
                    </Box> :
                    <Box padding="0px 18px" marginBottom="4px">
                        <Typography style={{fontSize: "14px", marginBottom: "4px", cursor: "pointer"}}>None</Typography>
                    </Box>
                }
                <Dialog
                    open={confirmation}
                    onClose={() => {
                        setConfirmation(false);
                    }}
                    scroll="body"
                    disableEnforceFocus
                >
                    <DialogTitle color="primary">
                        <Typography variant="h4">
                            Are you sure?
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Grid item container xs={12} spacing={2} alignContent="center">
                            <Grid xs={6} item>
                                <Button variant="contained" onClick={handleDelete} fullWidth color="secondary">Yes</Button>
                            </Grid>
                            <Grid xs={6}item>
                                <Button variant="contained" onClick={()=>setConfirmation(false)} fullWidth>No</Button>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openModal}
                    onClose={() => {
                        setOpenModal(false);
                    }}
                    classes={{paper: classes.dialog}}
                    scroll="body"
                    disableEnforceFocus
                >
                    <DialogTitle color="primary">
                        <Typography variant="h3">
                            General Information
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Grid item container xs={12} sm={9} spacing={2}>
                            <Grid xs={12} sm={3} item>
                                <Box position="relative" width="fit-content">
                                    {
                                        linkToImage ?
                                            <img
                                                src={linkToImage}
                                                onError={handleImageLoadError}
                                                width="100"
                                                height="100"
                                                style={{objectFit: "cover"}}
                                            />
                                            :
                                            ({
                                                "FELINE": <PetCatSVG/>,
                                                "CANINE": <PetDogSVG/>,
                                            }[selectedAnimal?.type] ||
                                            <Box display="flex" justifyContent="center"
                                                alignItems="center" width="100px"
                                                height="100px">
                                                <AddPetSVG/>
                                            </Box>
                                            )
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={12} container justify="space-between" alignItems="center">
                                <Grid item xs={4}>
                                    <Typography variant="body2" style={{marginRight: "50px"}}>
                                        Name
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        name="name"
                                        value={selectedAnimal?.name}
                                        variant="outlined"
                                        color="secondary"
                                        type="text"
                                        margin="dense"
                                        size="small"
                                        onChange={(e) => {
                                            setSelectedAnimal({...selectedAnimal, name: e.target.value});
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems="center">
                                <Grid item xs={4}>
                                    <Typography variant="body2">
                                        Type
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Select
                                        fullWidth
                                        name="type"
                                        variant="outlined"
                                        margin="dense"
                                        value={selectedAnimal?.type}
                                        onChange={(e) => {
                                            setSelectedAnimal({...selectedAnimal, type: e.target.value, breed: ""});
                                        }}
                                    >
                                        {rhapsodyPetTypes.map((item, idx) => <MenuItem key={idx}
                                            value={item.value}>{item.label}</MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems="center">
                                <Grid item xs={4}>
                                    <Typography variant="body2">
                                        Birthday
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            name="dateOfBirth"
                                            autoOk
                                            inputVariant="outlined"
                                            openTo="year"
                                            views={["year", "month", "date"]}
                                            value={selectedAnimal?.dateOfBirth}
                                            fullWidth={true}
                                            size="small"
                                            format="MM/dd/yyyy"
                                            disableFuture={true}
                                            maxDate={new Date()}
                                            minDate={new Date("1990-01-01")}
                                            onChange={(e) => {
                                                setSelectedAnimal({...selectedAnimal, dateOfBirth: moment(e).format("YYYY-MM-DD")});
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems="center">
                                <Grid item xs={4}>
                                    <Typography variant="body2">
                                        Breed
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    {selectedAnimal?.type === "CANINE" &&
                                        <Autocomplete
                                            fullWidth
                                            options={dogs}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={selectedAnimal?.breed}
                                            onChange={(event, value) => {
                                                setSelectedAnimal({...selectedAnimal, breed: value})
                                            }}
                                            renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} margin="dense" variant="outlined"
                                                    />
                                                </>
                                            }
                                        />
                                    }
                                    {selectedAnimal?.type === "FELINE" &&
                                        <Autocomplete
                                            fullWidth
                                            options={cats}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={selectedAnimal?.breed}
                                            onChange={(event, value) => {
                                                setSelectedAnimal({...selectedAnimal, breed: value})
                                            }}
                                            renderInput={(params) => <>
                                                <RTextField {...params} margin="dense" variant="outlined"
                                                />
                                            </>}
                                        />
                                    }
                                    {selectedAnimal?.type === "AVIAN" &&
                                        <Autocomplete
                                            fullWidth
                                            options={birds}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={selectedAnimal?.breed}
                                            onChange={(event, value) => {
                                                setSelectedAnimal({...selectedAnimal, breed: value})
                                            }}
                                            renderInput={(params) => <>
                                                <RTextField {...params} margin="dense" variant="outlined"
                                                />
                                            </>}
                                        />
                                    }
                                    {selectedAnimal?.type === "AMPHIBIAN" &&
                                        <Autocomplete
                                            fullWidth
                                            options={amphibians}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={selectedAnimal?.breed}
                                            onChange={(event, value) => {
                                                setSelectedAnimal({...selectedAnimal, breed: value})
                                            }}
                                            renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} margin="dense" variant="outlined"
                                                    />
                                                </>}
                                        />
                                    }
                                    {selectedAnimal?.type === "AQUATIC" &&
                                        <Autocomplete
                                            fullWidth
                                            options={aquatic}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={selectedAnimal?.breed}
                                            onChange={(event, value) => {
                                                setSelectedAnimal({...selectedAnimal, breed: value})
                                            }}
                                            renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} margin="dense" variant="outlined"
                                                    />
                                                </>}
                                        />
                                    }
                                    {selectedAnimal?.type === "MUSTELIDAE" &&
                                        <Autocomplete
                                            fullWidth
                                            options={mustelidae}
                                            disableClearable
                                            getOptionLabel={(option) => option}
                                            value={selectedAnimal?.breed}
                                            onChange={(event, value) => {
                                                setSelectedAnimal({...selectedAnimal, breed: value})
                                            }}
                                            renderInput={(params) =>
                                                <>
                                                    <RTextField {...params} margin="dense" variant="outlined"
                                                    />
                                                </>}
                                        />
                                    }
                                    {!["MUSTELIDAE", "AQUATIC", "AMPHIBIAN", "AVIAN", "FELINE", "CANINE"].includes(selectedAnimal?.type) &&
                                        <TextField
                                            fullWidth
                                            margin="dense"
                                            size="small"
                                            id="outlined-basic"
                                            variant="outlined"
                                            name="breed"
                                            value={selectedAnimal?.breed}
                                            onChange={(e) => {
                                                setSelectedAnimal({...selectedAnimal, breed: e.target.value});
                                            }}
                                        />}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems="center">
                                <Grid item xs={4}>
                                    <Typography variant="body2">
                                        Primary Color
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Autocomplete
                                        fullWidth
                                        options={generalColors}
                                        disableClearable
                                        getOptionLabel={(option) => option}
                                        value={selectedAnimal?.primaryColor}
                                        renderInput={(params) => <RTextField {...params} variant="outlined"/>}
                                        onChange={(event, value) => {
                                            setSelectedAnimal({...selectedAnimal, primaryColor: value});
                                        }}
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems="center">
                                <Grid item xs={4}>
                                    <Typography variant="body2" style={{paddingRight: 2}}>
                                        Secondary Color
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Autocomplete
                                        fullWidth
                                        options={generalColors}
                                        disableClearable
                                        getOptionLabel={(option) => option}
                                        value={selectedAnimal?.secondaryColor}
                                        renderInput={(params) => <RTextField {...params} variant="outlined"/>}
                                        onChange={(event, value) => {
                                            setSelectedAnimal({...selectedAnimal, secondaryColor: value});
                                        }}
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems="center">
                                <Grid item xs={4}>
                                    <Typography variant="body2">
                                        Weight
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        name="weight"
                                        value={selectedAnimal?.weight}
                                        variant="outlined"
                                        color="secondary"
                                        type="number"
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        onChange={(e) => {
                                            setSelectedAnimal({...selectedAnimal, weight: e.target.value});
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={3} style={{marginLeft: "5px"}}>
                                    <Typography variant="body2">
                                        lbs
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container alignItems="center" xs={12}>
                                <Grid item xs={4}>
                                    <Typography variant="body2">
                                        Sex
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    {/*@ts-ignore*/}
                                    <RadioGroup name="sex" value={selectedAnimal?.sex} row onChange={(event) => setSelectedAnimal({...selectedAnimal, sex: event.target.value})}>
                                        <FormControlLabel value="MALE" control={<Radio/>} label="Male"/>
                                        <FormControlLabel value="FEMALE" control={<Radio/>} label="Female"/>
                                    </RadioGroup>
                                </Grid>
                            </Grid>
                            <Grid item container alignItems="center" xs={12}>
                                <Grid item xs={4}>
                                    <Typography variant="body2">
                                        {selectedAnimal?.sex === "FEMALE" ? "Spayed" : "Neutered"}
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    {/*@ts-ignore*/}
                                    <RadioGroup name="neuteredSpayed" value={selectedAnimal?.neuteredSpayed} row onChange={(event) => {
                                        setSelectedAnimal({...selectedAnimal, neuteredSpayed: event.target.value === "true" ? true : false })
                                    }}>
                                        <FormControlLabel value={true} control={<Radio/>} label="Yes"/>
                                        <FormControlLabel value={false} control={<Radio/>} label="No"/>
                                    </RadioGroup>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container justify="space-between" alignItems="center">
                                <Grid item xs={4}>
                                    <Typography variant="body2" style={{marginRight: "50px"}}>
                                        Diet <span style={{fontWeight: 400, fontSize: "12px"}}>(Select all that apply)</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Autocomplete
                                        fullWidth
                                        multiple
                                        options={diets}
                                        getOptionLabel={(option) => option}
                                        renderInput={(params) => <RTextField {...params} variant="outlined"/>}
                                        value={selectedAnimal?.diet}
                                        onChange={(e, value) => {
                                            setSelectedAnimal({...selectedAnimal, diet: value});
                                        }}
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item container alignItems="center" xs={12}>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        Pet Insurance <span style={{fontWeight: 400, fontSize: "12px"}}>(If you have it)</span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        fullWidth
                                        options={insuranceList}
                                        getOptionLabel={(option) => option}
                                        value={selectedAnimal?.insuranceProvider}
                                        renderInput={(params) => <RTextField {...params} margin="dense" variant="outlined"/>}
                                        onChange={(e, value) => {
                                            setSelectedAnimal({...selectedAnimal, insuranceProvider: value});
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item container alignItems="center" xs={12}>
                                <Grid item xs={3}>
                                    <Typography variant="body2">
                                        Primary Care Vet
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <RadioGroupMUI name="pcv" value={primaryCare ? "yes" : "no"} row>
                                        <FormControlLabel onChange={() => setPrimaryCare(true)} value="yes" control={<Radio/>} label="Yes"/>
                                        <FormControlLabel onChange={() => setPrimaryCare(false)} value="no" control={<Radio/>} label="No"/>
                                    </RadioGroupMUI>
                                </Grid>
                            </Grid>
                            {primaryCare &&
                                <>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={4}>
                                            <Typography variant="body2">
                                                Clinic Name
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                name="birthday"
                                                value={primaryName}
                                                variant="outlined"
                                                color="secondary"
                                                type="text"
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                onChange={(event)=> setPrimaryName(event.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={4}>
                                            <Typography variant="body2">
                                                Phone Number
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                name="birthday"
                                                value={primaryPhone}
                                                variant="outlined"
                                                color="secondary"
                                                type="text"
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                onChange={(event) => setPrimaryPhone(event.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center">
                                        <Grid item xs={4}>
                                            <Typography variant="body2">
                                                Clinic Email
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                name="birthday"
                                                value={clinicEmail}
                                                variant="outlined"
                                                color="secondary"
                                                type="text"
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                onChange={(event) => setClinicEmail(event.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </DialogContent>
                    <div style={{alignItems: "center", paddingRight: 19, paddingLeft: 19}}>
                    <Button
                        color="secondary"
                        variant="contained"
                        className={classes.button}
                        onClick={handleNotes}
                    >
                        {!isNotesExpand ? "Expand Notes/History" : "Compress Notes/History"}
                    </Button>
                    {isNotesExpand && (
                        !isView ? (
                            <div className={classes.listNotes}>{
                                (recordsList?.length && !isLoading) ? (
                                    [...recordsList]
                                        .sort((a, b) => moment(b.created).diff(moment(a.created)))
                                        .map(({id, created, appointment, primaryVet}, idx) => {
                                            const vet = primaryVet;
                                            const title = appointment.status === "NOT_APPLICABLE" ? "In-Clinic Appointment" : `${getAppointmentType(appointment?.type)} ${vet?.lastName? (`- Dr. ${vet.lastName}`) : ""}`;
                                            const noteCreated = moment(created).format("MMMM DD, YYYY");
                                            return <NotesListItem
                                                key={idx}
                                                id={id}
                                                title={title}
                                                date={noteCreated}
                                                setSelectedRecord={handleNotesDetails}
                                                setOpenModal={setIsView}
                                                styles={(idx === recordsList.length - 1) ? "" : classes.itemDivider}
                                            />;
                                        })) :
                                    <Typography variant="h6">No medical records</Typography>}</div>) : (
                            <div className={classes.formContainer}>
                                <Grid item xs={12} sm={9}>
                                    <Box>
                                        <Typography variant="h4">{title}</Typography>
                                        <Typography color="textSecondary" className={classes.textSecondary}>{date}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box marginBottom="15px">
                                        <Typography variant="h4" className={classes.textPlain}>
                                            Subjective
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box marginBottom="20px">
                                        <TextField
                                            multiline
                                            fullWidth
                                            value={selectedRecord?.subjective}
                                            variant="outlined"
                                            disabled
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box marginBottom="15px">
                                        <Typography variant="h4" className={classes.textPlain}>
                                            Objective
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box marginBottom="20px">
                                        <TextField
                                            multiline
                                            fullWidth
                                            value={selectedRecord?.objective}
                                            variant="outlined"
                                            disabled
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box marginBottom="15px">
                                        <Typography variant="h4" className={classes.textPlain}>
                                            Assessment
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box marginBottom="20px">
                                        <TextField
                                            multiline
                                            fullWidth
                                            value={selectedRecord?.assessment}
                                            variant="outlined"
                                            disabled
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box marginBottom="15px">
                                        <Typography variant="h4" className={classes.textPlain}>
                                            Plan
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box marginBottom="20px">
                                        <TextField
                                            multiline
                                            fullWidth
                                            value={selectedRecord?.plan}
                                            variant="outlined"
                                            disabled
                                        />
                                    </Box>
                                </Grid>
                                <Button variant="contained" component="label"
                                    style={{height: 34}}
                                    onClick={() => {
                                        setIsView(false);
                                    }}>
                                    Close
                                </Button>
                            </div>)
                    )}
                    </div>
                    <DialogActions classes={{root: classes.actions}}
                    >
                        <Box display="flex" justifyContent="end" width="100%">
                            <Button variant="contained" color="primary"
                                disabled={
                                    !selectedAnimal?.name.length ||
                                    !selectedAnimal?.type.length ||
                                    !selectedAnimal?.breed.length ||
                                    !selectedAnimal?.dateOfBirth.length ||
                                    !selectedAnimal?.primaryColor.length ||
                                    !selectedAnimal?.weight
                                }
                                onClick={() => {
                                    handleSubmitPrimary();
                                    setOpenModal(false);
                                }}>
                                Save
                            </Button>
                        </Box>
                        <Box display="flex" justifyContent="flexStart" width="100%">
                            <Button variant="contained"
                                onClick={() => {
                                    setOpenModal(false);
                                }}>
                                Close
                            </Button>
                        </Box>
                    </DialogActions>
                </Dialog>
            </Accordion>
        </SimpleForm>
    );
};

export default PetParentProfile;
